function isTouch(): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return 'ontouchstart' in window || ((window as any).DocumentTouch && document instanceof (window as any).DocumentTouch);
}

export default isTouch;
